<template>
  <div id="releaseNotesViewer">
    <v-card class="screen-height-container flex-content">
      <v-card-title>
        <h2>Release Notes</h2>
        <v-spacer />
        <help-button
          help-topic-key="viewing-release-notes"
        />
        <v-btn icon  @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text >
        <v-data-table
          :headers="headers"
          :items="data"
          fixed-header
          :single-expand="true"
          height="100%"
          :loading="isLoading"
          hide-default-footer
          show-expand
          :expanded.sync="expanded"
          must-sort
          :options="pagination"
          style="border:1px solid silver"

        >
          <template
            v-slot:item.releaseDate="{ item }"
          >{{moment(item.releaseDate).format('MM/DD/YYYY')}}</template>
          <template v-slot:item.updatedate="{ item }">
            <span style="white-space:nowrap" v-html="formatDateWithHTML(item.updatedate)" />
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div v-html="item.notes" style="padding: 10px" />
              <div class="justify-center" v-if="item.fileUrl">
                <v-btn
                  outlined
                  color="primary"
                  small
                  @click="showVideo(item)"
                >View Demonstration of New Features</v-btn>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-dialog v-model="showDemoVideo" width="45%" v-if="showDemoVideo">
        <video-viewer :url="selectedItem.fileUrl" @close="showDemoVideo=false" />
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import BaseMixin from "@/mixins/base.js";
import { mapGetters } from "vuex";
import Vue from "vue";
import VideoViewer from "./VideoViewer.vue";
import HelpButton from "@/components/systemadmin/helpTopics/HelpButton";
export default {
  components: {HelpButton, VideoViewer },
  mixins: [BaseMixin],
  data() {
    return {
      moment: moment,
      Trimaster: Trimaster,
      isLoading: false,
      data: [],
      expanded: [],
      showDemoVideo: false,
      selectedItem: null,
      pagination: {
        sortBy: ["version"],
        itemsPerPage: -1,
        sortDesc: [true],
        groupBy: ['component']
      },
      headers: [
        {
          text: "Component",
          value: "component",
          groupable: true
        },
        {
          text: "Version",
          value: "version",
          groupable: false,
          width: 100
        },
        {
          text: "Synopsis",
          value: "label",
          sortable: false,
          groupable: false
        },
        {
          text: "Release Date",
          value: "releaseDate",
          groupable: false,
          width: 130
        },
        { text: "", value: "data-table-expand" }
      ]
    };
  },

  watch: {
    expanded(newVal,oldVal) {
      if (Array.isArray(newVal)) {
        this.onExpand(newVal[0]);
      }
    }
  },

  beforeMount() {
    let me = this;
    Trimaster.get("ag_releaseNotes", this.getUser.apitoken, {
      filter: {
        fields: [
          "id",
          "version",
          "label",
          "releaseDate",
          "updatedate",
          "fileUrl",
          "component"
        ],
        where: {
          releaseDate: { lt: moment().format("YYYY-MM-DD") }
        }
      }
    }).then(function([res, err]) {
      for (let i = 0; i < res.length; i++) {

        let d = moment(res[i].releaseDate.split("T")[0],"YYYY-MM-DD").format("MM/DD/YYYY");
        res[i].releaseDate = d;
        res[i].notes = "";
      }
      me.data = res;
    });
  },

  methods: {
    onExpand(item) {
      let me = this;
      if (item && item.notes == "") {
         this.isLoading = true;
        Trimaster.get("ag_releaseNotes/" + item.id, this.getUser.apitoken).then(
          function([res, err]) {
            me.isLoading = false;
            item.notes = res.notes;
          }
        );
      }
    },
    showVideo(item) {
      this.selectedItem = item;
      this.showDemoVideo = true;
    }
  },

  computed: {
    ...mapGetters(["getUser"])
  }
};
</script>

<style>
</style>
